import { render, staticRenderFns } from "./ZealInstructorIcard.vue?vue&type=template&id=01059e8e&scoped=true&"
import script from "./ZealInstructorIcard.vue?vue&type=script&lang=js&"
export * from "./ZealInstructorIcard.vue?vue&type=script&lang=js&"
import style0 from "./ZealInstructorIcard.vue?vue&type=style&index=0&id=01059e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01059e8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VImg,VRadio,VRadioGroup,VRow})
